import { render } from "./WidgetLayout.vue?vue&type=template&id=61856f2c"
import script from "./WidgetLayout.vue?vue&type=script&lang=js"
export * from "./WidgetLayout.vue?vue&type=script&lang=js"

import "./WidgetLayout.vue?vue&type=style&index=0&id=61856f2c&lang=scss"
script.render = render

export default script